import React, { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Paper,
  FormControl,
  IconButton,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import colors from "../../../assest/theme/base/colors";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import { CREATEINDUSTRY, UPDATEINDUSTRYBYID } from "./Mutation";
import { postItem, updateItem } from "../../../BaseUrl";

const AddIndustryMaster = ({
  formClose,
  setPopup,
  getIndustryData,
  oneIndustryData,
  isView,
  setDialogData,
  handleOpenDialog,
}) => {
  const [industryData, setIndustryData] = useState({
    industryType: "",
    hiringType: {
      lateral: false,
      bulk: false,
    },
    industryTypeStatus: "unchecked",
  });

  //edit and view data fetch
  useEffect(() => {
    if (oneIndustryData.length > 0) {
      const data = oneIndustryData[0];
      setIndustryData({
        industryType: data.industryType || "", // Set the industry type
        hiringType: {
          lateral: data.hiringType === "Lateral Hiring", // Check if hiringType matches "Lateral Hiring"
          bulk: data.hiringType === "Bulk Hiring", // Check if hiringType matches "Bulk Hiring"
        },
        industryTypeStatus: "success",
      });
    }
  }, [oneIndustryData]);

  //onchange function
  const handleAddIndustryChange = (event) => {
    const { name, value, checked } = event.target;
    let formState = { ...industryData };

    if (name === "industryType") {
      const alphaNLengthRegex = new RegExp("^.{1,50}$");
      if (alphaNLengthRegex.test(value.trim())) {
        formState.industryTypeStatus = "success";
      } else {
        formState.industryTypeStatus = value === "" ? "unchecked" : "error";
      }
      formState.industryType = value;
    } else if (name === "hiringType") {
      formState.hiringType = {
        lateral: value === "lateral" ? checked : false,
        bulk: value === "bulk" ? checked : false,
      };
    }

    setIndustryData(formState);
  };

  const isButtonDisabled = () => {
    return industryData.industryTypeStatus === "unchecked" || (!industryData.hiringType.lateral && !industryData.hiringType.bulk) ;
  };

  //reset form
  const resetForm = () => {
    formClose();
    setIndustryData({
      industryType: "",
      hiringType: {
        lateral: false,
        bulk: false,
      },
      industryTypeStatus: "unchecked",
    });
  };

  const onSubmitOpen = () => {
    handleOpenDialog();
    setDialogData({
      title: `${oneIndustryData.length > 0 ? "Update" : "Create"} industry ?`,
      content: `Are you sure you want to ${
        oneIndustryData.length > 0 ? "Update" : "Create"
      } industry ?`,
      onConfirm: () => handleSubmit(),
    });
  };

  //submit form
  const handleSubmit = async () => {
    try {
      //update api call
      if (oneIndustryData.length > 0) {
        const variables = {
          id: oneIndustryData[0].id,
          industryType: industryData.industryType, // Mapping `industryType` to `industryType`
          hiringType: industryData.hiringType.lateral
            ? "Lateral Hiring"
            : "Bulk Hiring",
        };
        const response = await updateItem(UPDATEINDUSTRYBYID, {
          input: variables,
        });
        if (response?.updateIndustry?.success === true) {
          setPopup({
            open: true,
            message: response?.updateIndustry?.message,
            severity: "success",
          });
        } else {
          setPopup({
            open: true,
            message: response?.updateIndustry?.message,
            severity: "error",
          });
        }
      } else {
        //Post api call
        const variables = {
          industryType: industryData.industryType, // Mapping `industryType` to `industryType`
          hiringType: industryData.hiringType.lateral
            ? "Lateral Hiring"
            : "Bulk Hiring",
        };
        const response = await postItem(CREATEINDUSTRY, { input: variables });
        if (response?.createIndustry?.success === true) {
          setPopup({
            open: true,
            message: response?.createIndustry?.message,
            severity: "success",
          });
        } else {
          setPopup({
            open: true,
            message: response?.createIndustry?.message,
            severity: "error",
          });
        }
      }
    } catch (error) {
      console.error(error);
      setPopup({
        open: true,
        message: error,
        severity: "error",
      });
    } finally {
      resetForm();
      getIndustryData();
    }
  };

  return (
    <Paper sx={{ p: 4, width: 400, mx: "auto", borderRadius: 4 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", gap: 4 }}>
          <IconButton onClick={resetForm}>
            <ArrowBackIcon sx={{ color: "#000" }} />
          </IconButton>{" "}
          <MaterialTypography
            sx={{ fontSize: "18px", fontWeight: "bold", mt: 2 }}
            mb={2}
          >
            {oneIndustryData.length > 0 ? "Update" : "New"} Industry
          </MaterialTypography>
        </Box>
        <IconButton onClick={resetForm}>
          <ClearIcon sx={{ color: "#000" }} />
        </IconButton>
      </Box>

      <form>
        <FormControl fullWidth>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
            sx={{ color: "black" }}
          >
            Industry Type
          </MaterialTypography>
          <MaterialInput
            fullWidth
            disabled={isView}
            name="industryType"
            variant="standard"
            value={industryData.industryType}
            onChange={handleAddIndustryChange}
            error={industryData.industryTypeStatus === "error"}
            success={industryData.industryTypeStatus === "success"}
          />
        </FormControl>

        <Box mt={2}>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
            sx={{ color: "black" }}
          >
            Hiring Type
          </MaterialTypography>
          <Box sx={{ display: "flex", gap: 2, pl: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  name="hiringType"
                  value="lateral"
                  checked={industryData.hiringType.lateral}
                  onChange={handleAddIndustryChange}
                  disabled={isView}
                />
              }
              label="Lateral Hiring"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="hiringType"
                  value="bulk"
                  checked={industryData.hiringType.bulk}
                  onChange={handleAddIndustryChange}
                  disabled={isView}
                />
              }
              label="Bulk Hiring"
            />
          </Box>
        </Box>

        {!isView && (
          <Box display="flex" justifyContent="space-around" mt={3}>
            <MaterialButton
              variant="contained"
              sx={{
                background: colors.buttonColor,
                color: "#fff",
                textTransform: "capitalize",
              }}
               disabled={isButtonDisabled()}
              onClick={onSubmitOpen}
            >
              {oneIndustryData.length > 0 ? "Update" : "Submit"}
            </MaterialButton>
            <MaterialButton
              onClick={resetForm}
              variant="outlined"
              color="error"
            >
              Cancel
            </MaterialButton>
          </Box>
        )}
      </form>
    </Paper>
  );
};

export default AddIndustryMaster;
